// v3/config/navigation.config.ts — Sidebar navigation items
//
// All imports from v3 — zero imports from v1/v2.
// Each item has a featureId for permission filtering via canAccessFeature().

import type { NavigationItem } from './types';

// ─── Sidebar Navigation Items ────────────────────────────────────────────────

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Dashboard',
    path: '/',
    icon: 'House',
    featureId: 'dashboard',
    bottomNav: 1,
    shortLabel: 'Home',
  },
  {
    label: 'Leads',
    path: '/leads',
    icon: 'Users',
    featureId: 'leads',
    bottomNav: 3,
  },
  {
    label: 'Applications',
    path: '/applications',
    icon: 'FileText',
    featureId: 'applications',
    bottomNav: 2,
    shortLabel: 'Apps',
  },
  {
    label: 'Groups',
    path: '/groups',
    icon: 'UsersRound',
    featureId: 'groups',
    bottomNav: 4,
  },
  {
    label: 'Tasks',
    path: '/tasks',
    icon: 'ListChecks',
    featureId: 'tasks',
    bottomNav: 5,
  },
  {
    label: 'Login History',
    path: '/login-history',
    icon: 'History',
    featureId: 'login-history',
  },
  {
    label: 'EMI Calculator',
    path: '/emi-calculator',
    icon: 'Calculator',
    featureId: 'emi-calculator',
  },
  {
    label: 'Settings',
    path: '/settings',
    icon: 'Settings',
    featureId: 'settings',
  },
];
